module.exports = "\n<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <nav>\n      <ul>\n        <li>\n          <a href=\"http://webbanana.in/\">\n           WebBanana\n          </a>\n        </li>\n        <li>\n          <a href=\"http://webbanana.in/about\">\n           About\n          </a>\n        </li>\n       \n      </ul>\n    </nav>\n    <div class=\"copyright\">\n      &copy;\n      {{test | date: 'yyyy'}}, Designed by WebBanana.\n     \n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main